module.exports = __webpack_public_path__ + "static/media/Google Pixel 3 XL - Not Pink.653e934e.png";